import { config } from "./../../config";

const Tos = () => {
    const { appName, contactDetails } = config;
    
    return (
        <div className="min-h-[calc(100vh-200px)] px-4 sm:px-6 lg:px-8 py-12">
            <div className="max-w-6xl mx-auto">
                {/* Header */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Terms & Conditions</h1>
                    <div className="w-24 h-1 bg-blue-600 mx-auto mb-4"></div>
                    <p className="text-lg text-gray-600">
                        Last updated: {new Date().toLocaleDateString('en-US', { 
                            year: 'numeric', 
                            month: 'long', 
                            day: 'numeric' 
                        })}
                    </p>
                </div>
                
                <div className=" p-8">
                    {/* Important Notice */}
                    <div className="mb-10 p-6 bg-red-50 rounded-xl border-2 border-red-200">
                        <div className="flex items-start">
                            <svg className="w-6 h-6 text-red-600 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.998-.833-2.732 0L4.34 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                            </svg>
                            <div>
                                <h3 className="text-xl font-bold text-gray-900 mb-2">Important Notice</h3>
                                <p className="text-gray-700">
                                    Please read these Terms and Conditions carefully before using {appName}'s services. 
                                    By accessing or using our services, you agree to be bound by these terms. If you do not 
                                    agree with any part of these terms, you must not use our services.
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="space-y-12">
                        {/* Acceptance of Terms */}
                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b border-gray-200 flex items-center">
                                <span className="bg-blue-100 text-blue-800 w-8 h-8 rounded-full flex items-center justify-center mr-3">1</span>
                                Acceptance of Terms
                            </h2>
                            <div className="space-y-4 text-gray-700">
                                <p>
                                    By accessing and using the {appName} website, mobile application, or any related services 
                                    (collectively, the "Services"), you accept and agree to be bound by these Terms and Conditions, 
                                    our Privacy Policy, and all applicable laws and regulations.
                                </p>
                                <div className="bg-gray-50 p-4 rounded-lg">
                                    <p className="font-semibold text-gray-800 mb-2">Eligibility:</p>
                                    <p>
                                        You must be at least 16 years old to use our Services. By using our Services, you 
                                        represent and warrant that you are of legal age to form a binding contract.
                                    </p>
                                </div>
                            </div>
                        </section>
                        
                        {/* Booking Terms */}
                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b border-gray-200 flex items-center">
                                <span className="bg-blue-100 text-blue-800 w-8 h-8 rounded-full flex items-center justify-center mr-3">2</span>
                                Booking and Ticketing Terms
                            </h2>
                            <div className="space-y-6">
                                <div className="bg-blue-50 p-5 rounded-lg">
                                    <h4 className="font-semibold text-gray-800 mb-2">Booking Confirmation</h4>
                                    <p className="text-gray-700">
                                        A booking is confirmed only after full payment is received and a booking confirmation 
                                        is sent to your registered email/mobile number. We reserve the right to cancel any 
                                        booking if full payment is not received.
                                    </p>
                                </div>
                                
                                <div>
                                    <h4 className="text-xl font-semibold text-gray-800 mb-3">Fare Rules</h4>
                                    <ul className="list-disc pl-6 space-y-2 text-gray-700">
                                        <li>All fares are subject to availability and may change without prior notice</li>
                                        <li>Additional convenience fees and taxes may apply</li>
                                        <li>Special fares may have specific terms and restrictions</li>
                                        <li>Fare differences may apply for date/time changes</li>
                                    </ul>
                                </div>
                                
                                <div>
                                    <h4 className="text-xl font-semibold text-gray-800 mb-3">Identification Requirements</h4>
                                    <p className="text-gray-700 mb-3">
                                        Passengers must carry valid government-issued photo identification matching the booking 
                                        details. The following documents are accepted:
                                    </p>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                        <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm text-center">Aadhaar Card</span>
                                        <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm text-center">PAN Card</span>
                                        <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm text-center">Passport</span>
                                        <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm text-center">Driver's License</span>
                                        <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm text-center">Voter ID Card</span>
                                    </div>
                                </div>
                            </div>
                        </section>
                        
                        {/* Cancellation and Refund */}
                        {/* <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b border-gray-200 flex items-center">
                                <span className="bg-blue-100 text-blue-800 w-8 h-8 rounded-full flex items-center justify-center mr-3">3</span>
                                Cancellation and Refund Policy
                            </h2>
                            <div className="space-y-6">
                                <div className="bg-yellow-50 p-5 rounded-lg border border-yellow-200">
                                    <h4 className="font-semibold text-gray-800 mb-2">Important: Refund Policy</h4>
                                    <p className="text-gray-700">
                                        All cancellations and refunds are subject to the following terms. Refund amounts 
                                        depend on when the cancellation is made relative to the departure time.
                                    </p>
                                </div>
                                
                                <div className="overflow-x-auto">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Cancellation Time</th>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Refund Amount</th>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Charges</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            <tr>
                                                <td className="px-6 py-4 whitespace-nowrap text-gray-700">More than 48 hours before departure</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-green-600 font-medium">80% of fare</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-gray-700">20% cancellation charge</td>
                                            </tr>
                                            <tr className="bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-gray-700">24-48 hours before departure</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-yellow-600 font-medium">50% of fare</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-gray-700">50% cancellation charge</td>
                                            </tr>
                                            <tr>
                                                <td className="px-6 py-4 whitespace-nowrap text-gray-700">Less than 24 hours before departure</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-red-600 font-medium">No Refund</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-gray-700">100% cancellation charge</td>
                                            </tr>
                                            <tr className="bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-gray-700">After departure</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-red-600 font-medium">No Refund</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-gray-700">100% cancellation charge</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                
                                <div className="bg-red-50 p-4 rounded-lg">
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Note:</span> Convenience fees and taxes are non-refundable. 
                                        Partial trip cancellations are not permitted. Refunds will be processed within 7-10 business 
                                        days to the original payment method.
                                    </p>
                                </div>
                            </div>
                        </section> */}
                        
                        {/* User Responsibilities */}
                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b border-gray-200 flex items-center">
                                <span className="bg-blue-100 text-blue-800 w-8 h-8 rounded-full flex items-center justify-center mr-3">4</span>
                                User Responsibilities
                            </h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="bg-gray-50 p-5 rounded-lg">
                                    <h4 className="font-semibold text-gray-800 mb-3">Account Security</h4>
                                    <ul className="space-y-2 text-gray-700">
                                        <li>• Maintain confidentiality of your account credentials</li>
                                        <li>• Notify us immediately of unauthorized access</li>
                                        <li>• You are responsible for all activities under your account</li>
                                    </ul>
                                </div>
                                <div className="bg-gray-50 p-5 rounded-lg">
                                    <h4 className="font-semibold text-gray-800 mb-3">Prohibited Activities</h4>
                                    <ul className="space-y-2 text-gray-700">
                                        <li>• Using the service for illegal purposes</li>
                                        <li>• Attempting to circumvent security measures</li>
                                        <li>• Reselling tickets without authorization</li>
                                        <li>• Harassing other users or staff</li>
                                    </ul>
                                </div>
                            </div>
                        </section>
                        
                        {/* Limitation of Liability */}
                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b border-gray-200 flex items-center">
                                <span className="bg-blue-100 text-blue-800 w-8 h-8 rounded-full flex items-center justify-center mr-3">5</span>
                                Limitation of Liability
                            </h2>
                            <div className="bg-gray-50 p-6 rounded-xl">
                                <p className="text-gray-700 mb-4">
                                    To the maximum extent permitted by law, {appName} and its affiliates shall not be liable for:
                                </p>
                                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                                    <li>Any indirect, incidental, special, consequential, or punitive damages</li>
                                    <li>Loss of profits, data, use, goodwill, or other intangible losses</li>
                                    <li>Delays, cancellations, or disruptions beyond our reasonable control</li>
                                    <li>Acts or omissions of third-party service providers</li>
                                    <li>Personal injury or property damage occurring during travel</li>
                                </ul>
                                <div className="mt-6 p-4 bg-blue-100 rounded-lg">
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Maximum Liability:</span> In no event shall our total liability 
                                        exceed the amount paid by you for the specific booking giving rise to the claim.
                                    </p>
                                </div>
                            </div>
                        </section>
                        
                        {/* Dispute Resolution */}
                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b border-gray-200 flex items-center">
                                <span className="bg-blue-100 text-blue-800 w-8 h-8 rounded-full flex items-center justify-center mr-3">6</span>
                                Dispute Resolution
                            </h2>
                            <div className="space-y-4 text-gray-700">
                                <p>
                                    Any disputes arising from these Terms or your use of our Services shall be resolved 
                                    through the following process:
                                </p>
                                <ol className="list-decimal pl-6 space-y-3">
                                    <li>
                                        <span className="font-semibold">Informal Negotiation:</span> Parties shall attempt to resolve 
                                        disputes amicably within 30 days.
                                    </li>
                                    <li>
                                        <span className="font-semibold">Mediation:</span> If unresolved, parties agree to mediation 
                                        before pursuing legal action.
                                    </li>
                                    <li>
                                        <span className="font-semibold">Governing Law:</span> These Terms shall be governed by the 
                                        laws of India, without regard to conflict of law principles.
                                    </li>
                                    <li>
                                        <span className="font-semibold">Jurisdiction:</span> Any legal proceedings shall be subject 
                                        to the exclusive jurisdiction of courts in {contactDetails.address}.
                                    </li>
                                </ol>
                            </div>
                        </section>
                        
                        {/* Force Majeure */}
                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b border-gray-200 flex items-center">
                                <span className="bg-blue-100 text-blue-800 w-8 h-8 rounded-full flex items-center justify-center mr-3">7</span>
                                Force Majeure
                            </h2>
                            <div className="bg-red-50 p-5 rounded-lg border border-red-200">
                                <p className="text-gray-700">
                                    We shall not be liable for any failure or delay in performance due to circumstances 
                                    beyond our reasonable control, including but not limited to:
                                </p>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">
                                    <span className="bg-white px-3 py-1 rounded-full text-sm text-center">Natural Disasters</span>
                                    <span className="bg-white px-3 py-1 rounded-full text-sm text-center">Government Actions</span>
                                    <span className="bg-white px-3 py-1 rounded-full text-sm text-center">Strikes/Lockouts</span>
                                    <span className="bg-white px-3 py-1 rounded-full text-sm text-center">Pandemics</span>
                                    <span className="bg-white px-3 py-1 rounded-full text-sm text-center">War/Terrorism</span>
                                    <span className="bg-white px-3 py-1 rounded-full text-sm text-center">Technical Failures</span>
                                </div>
                            </div>
                        </section>
                        
                        {/* Modifications */}
                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b border-gray-200 flex items-center">
                                <span className="bg-blue-100 text-blue-800 w-8 h-8 rounded-full flex items-center justify-center mr-3">8</span>
                                Modifications to Terms
                            </h2>
                            <div className="bg-blue-50 p-5 rounded-lg">
                                <p className="text-gray-700">
                                    We reserve the right to modify these Terms at any time. We will notify users of 
                                    material changes via email or through our Services. Your continued use of our 
                                    Services after such modifications constitutes your acceptance of the revised Terms.
                                </p>
                                <div className="mt-4 flex items-center text-gray-600">
                                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                    <p className="text-sm">
                                        It is your responsibility to review these Terms periodically for updates.
                                    </p>
                                </div>
                            </div>
                        </section>
                        
                        {/* Contact Information */}
                        <section className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8 rounded-xl border border-blue-200">
                            <h2 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h2>
                            <p className="text-gray-700 mb-6">
                                For questions about these Terms & Conditions, please contact us:
                            </p>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                <div>
                                    <h4 className="font-semibold text-gray-800 mb-2">Email</h4>
                                    <a href={`mailto:${contactDetails.email}?subject=Terms and Conditions Inquiry`} 
                                       className="text-blue-600 hover:text-blue-800">
                                        {contactDetails.email}
                                    </a>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-800 mb-2">Phone</h4>
                                    <a href={`tel:${contactDetails.phone.replace('+', '')}`} 
                                       className="text-blue-600 hover:text-blue-800">
                                        {contactDetails.phone}
                                    </a>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-800 mb-2">Helpline</h4>
                                    <a href={`tel:${contactDetails.helplineNo}`} 
                                       className="text-blue-600 hover:text-blue-800">
                                        {contactDetails.helplineNo}
                                    </a>
                                </div>
                                <div className="md:col-span-3">
                                    <h4 className="font-semibold text-gray-800 mb-2">Registered Office</h4>
                                    <p className="text-gray-700">{contactDetails.address}</p>
                                </div>
                            </div>
                        </section>
                        
                        {/* Acceptance Section */}
                        <div className="text-center p-6 bg-gray-50 rounded-xl border-2 border-gray-300">
                            <p className="text-gray-700 mb-4">
                                By using our Services, you acknowledge that you have read, understood, and agree to be 
                                bound by these Terms and Conditions.
                            </p>
                            <div className="flex items-center justify-center">
                                <svg className="w-6 h-6 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                                </svg>
                                <span className="font-semibold text-gray-800">Thank you for choosing {appName}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tos;